import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import WebsiteDev from "../pages/services/website-development/page";
import AiAuto from "../pages/services/ai-automation/page";
import SeoMarketing from "../pages/services/seo-marketing/page";
import VideoEditing from "../pages/services/video-editing/page";
import SocialAnalytics from "../pages/services/social-analytics/page";
import Hosting from "../pages/services/hosting/page";
import MetaAds from "../pages/services/meta-ads/page";
import Portfolio from "../pages/portfolio/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Cookies from "../pages/cookies/page";
import AdminLogin from "../pages/admin/login/page";
import AdminResetPassword from "../pages/admin/reset-password/page";
import AdminLayout from "../pages/admin/AdminLayout";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminInquiries from "../pages/admin/inquiries/page";
import AdminHistory from "../pages/admin/history/page";
import AdminPortfolio from "../pages/admin/portfolio/page";
import AdminContent from "../pages/admin/content/page";
import AdminSettings from "../pages/admin/settings/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/website-development", element: <WebsiteDev /> },
  { path: "/services/ai-automation", element: <AiAuto /> },
  { path: "/services/seo-marketing", element: <SeoMarketing /> },
  { path: "/services/video-editing", element: <VideoEditing /> },
  { path: "/services/social-analytics", element: <SocialAnalytics /> },
  { path: "/services/hosting", element: <Hosting /> },
  { path: "/services/meta-ads", element: <MetaAds /> },
  { path: "/portfolio", element: <Portfolio /> },
  { path: "/contact", element: <Contact /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "/cookies", element: <Cookies /> },
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin/reset-password", element: <AdminResetPassword /> },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { path: "dashboard", element: <AdminDashboard /> },
      { path: "inquiries", element: <AdminInquiries /> },
      { path: "history", element: <AdminHistory /> },
      { path: "portfolio", element: <AdminPortfolio /> },
      { path: "content", element: <AdminContent /> },
      { path: "settings", element: <AdminSettings /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;